import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ContextMenu from '../ContextMenu';
import Pile from '../Pile';
import { DISCARD } from '../ActiveGame/contextMenuTypes';
import { selectDiscardPile, selectPlayer } from '../ActiveGame/selectors';

const DiscardPileContextMenu = ({ userId }) => {
  const discardPile = useSelector((state) => selectDiscardPile(state, { userId }));
  const player = useSelector(selectPlayer);

  if (!discardPile) {
    return null;
  }

  const mine = userId === player.getIn(['user', 'id']);
  const count = discardPile.get('cards').size;

  return (
    <ContextMenu
      menu={DISCARD}
      userId={userId}
      title={`${mine ? 'Your' : "Opponent's"} discard pile · ${count}`}
    >
      <Pile cardsOrCardables={discardPile.get('cards')} newestFirst />
    </ContextMenu>
  );
};

DiscardPileContextMenu.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default DiscardPileContextMenu;
